import { Reveal, RevealLine } from "../lib/motion";
import { motion } from "framer-motion";

const PHASES = [
  { n: "01", title: "Vision", desc: "Definiamo direzione strategica e ambizione di lungo periodo del board." },
  { n: "02", title: "Assess", desc: "Valutiamo maturità, rischi e capacità dell'organizzazione con metodo." },
  { n: "03", title: "Prioritize", desc: "Identifichiamo le iniziative che generano il massimo valore." },
  { n: "04", title: "Transform", desc: "Guidiamo l'esecuzione tra governance, persone e tecnologia." },
  { n: "05", title: "Measure", desc: "Misuriamo l'impatto con metriche chiare e reporting per il board." },
];

export const Framework = () => (
  <section id="framework" data-testid="framework-section" className="py-24 sm:py-32 bg-[var(--paper-2)]">
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <div className="max-w-2xl mb-20">
        <div className="overline mb-6">GR Executive Framework™</div>
        <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)]">
          <RevealLine>Un metodo,</RevealLine>
          <RevealLine delay={0.08} className="italic text-[var(--petrol)]">dalla strategia all'impatto.</RevealLine>
        </h2>
      </div>

      <div className="relative">
        {/* connecting line — desktop */}
        <div className="hidden lg:block absolute left-0 right-0 top-[26px] h-px bg-[var(--line)]" />
        <motion.div
          className="hidden lg:block absolute left-0 right-0 top-[26px] h-px bg-[var(--gold)] origin-left"
          initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        />

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-x-8 gap-y-10">
          {PHASES.map((p, i) => (
            <Reveal key={p.n} delay={0.2 + i * 0.15} className="relative flex lg:block gap-5">
              {/* node */}
              <div className="relative shrink-0">
                <div className="w-[52px] h-[52px] rounded-full bg-[var(--paper-2)] border border-[var(--gold)] flex items-center justify-center font-serif text-lg text-[var(--petrol)]">
                  {p.n}
                </div>
                {/* vertical connector — mobile */}
                {i < PHASES.length - 1 && (
                  <div className="lg:hidden absolute left-1/2 top-[52px] -translate-x-1/2 w-px h-[calc(100%+2.5rem)] bg-[var(--line)]" />
                )}
              </div>
              <div className="lg:mt-8">
                <h3 className="font-serif text-2xl text-[var(--ink)] mb-2">{p.title}</h3>
                <p className="text-sm text-[var(--ink-soft)] leading-relaxed lg:pr-4">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.4} className="mt-20 max-w-3xl border-t border-[var(--line)] pt-10">
        <p className="font-serif text-2xl sm:text-3xl italic text-[var(--petrol)] leading-snug">
          Dalla visione alle decisioni. Dalle decisioni al valore.
        </p>
      </Reveal>
    </div>
  </section>
);
